export default __webpack_public_path__ + "static/Mont-SemiBold-8979d71a3146ca1d761f19cd42d50396.otf";